"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var I18n = require("i18n-js");
function formatDate(date, dateFormat) {
    if (isInvalidDate(date)) {
        return I18n.t('invalidDate');
    }
    return moment(date).format(dateFormat);
}
exports.formatDate = formatDate;
function formatInternationalizedSeconds(seconds, format) {
    if (format === void 0) { format = 'L'; }
    var t = new Date(1970, 0, 1);
    t.setSeconds(seconds);
    return formatInternationalizedDate(t, format);
}
exports.formatInternationalizedSeconds = formatInternationalizedSeconds;
function formatInternationalizedDate(date, format) {
    if (format === void 0) { format = 'L'; }
    return moment(date).format(format);
}
exports.formatInternationalizedDate = formatInternationalizedDate;
function isInvalidDate(val) {
    return !val || new Date(val).toString() === 'Invalid Date';
}
function getDate(dateString) {
    if (isInvalidDate(dateString)) {
        return I18n.t('invalidDate');
    }
    return moment(dateString).format('MMMM D, gggg');
}
exports.getDate = getDate;
function dateFromToday(numberOfDays, direction) {
    var dateFromToday = moment.utc(Date.now());
    if (direction === 'future') {
        dateFromToday = dateFromToday.add(numberOfDays, 'd');
    }
    else if (direction === 'past') {
        dateFromToday = dateFromToday.subtract(numberOfDays, 'd');
    }
    return dateFromToday.toDate();
}
exports.dateFromToday = dateFromToday;
//# sourceMappingURL=date_utils.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/date_utils.js
// module id = 8rAi
// module chunks = 20 21